import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import Panel from './Panel';
import Bottom from './Bottom';
import axios from 'axios';
import { format } from 'date-fns';

function Home(props) {
  const navigate = useNavigate();
  const { state } = useLocation();
  let userSession = state && state.values ? state.values : null;
  if (!userSession) {
    const storedSession = localStorage.getItem('userSession');
    if (storedSession) {
      userSession = JSON.parse(storedSession);
    }
  }
  const [providersList, setProvidersList] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState('');
  const [gamesList, setGamesList] = useState([]);
  const [launchUrl, setLaunchUrl] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [updatedState, setUpdatedState] = useState([]);

  // Use the user's actual agent credentials from the session
  const agent_code = state.values.agent_code;
  const agent_token = state.values.agent_token;

  console.log('Using agent credentials from session:');
  console.log('agent_code:', agent_code);
  console.log('agent_token:', agent_token);
  console.log('user_code:', state.values.user_code);
  // Function to handle back button click
  useEffect(() => {
    const handleBackButton = () => {
      // Navigate to the home page when the back button is clicked
      navigate('/home');
    };
    // Listen for the 'popstate' event which is triggered when the back button is clicked
    window.addEventListener('popstate', handleBackButton);
    return () => {
      // Remove the event listener when the component is unmounted
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);
  const logged = true;
  // Callback function to update the state with values from Panel.js
  const updateValues = (values) => {
    setUpdatedState(values);
  };
  //console.log('state at home ', state)
  //console.log('updatedState at home ',updatedState) 

  // 12 PROVIDER
  useEffect(() => {
    // Make the Axios request to get providers list
    const fetchProvidersList = async () => {
      try {
      const response = await axios.post('/api', {
          method: 'provider_list',
          agent_code: agent_code,
          agent_token: agent_token,
          user_code: state.values.user_code,
        });
      
      console.log('Home response.data ', response.data);
      
      // Check for error response
      if (response.data.status === 0) {
        console.warn('API error:', response.data.msg);
        if (response.data.msg === 'Rate Limit Error') {
          console.warn('Rate limit error, retrying in 2 seconds...');
          setTimeout(() => fetchProvidersList(), 2000);
          return;
        }
        setProvidersList([]);
        return;
      }
      
      // Check if providers exists in the data field
      const providers = response.data.data?.providers || response.data.providers;
      if (providers && Array.isArray(providers)) {
        setProvidersList(providers);
        if (providers.length > 0) {
          // Select PRAGMATIC (slot games) instead of PRAGMATICLIVE (live games)
          const pragmaticProvider = providers.find(p => p.code === 'PRAGMATIC');
          const selectedCode = pragmaticProvider ? pragmaticProvider.code : providers[0].code;
          setSelectedProvider(selectedCode);
          console.log('Selected provider:', selectedCode);
        }
      } else {
        console.warn('No providers data received');
        setProvidersList([]);
        }
      } catch (error) {
        console.error('Error fetching providers list:', error);
      setProvidersList([]); // Set empty array to prevent crashes
      }
    };
  fetchProvidersList();
}, []);

  useEffect(() => {
    // Make the Axios request to get game list based on the selected provider
    const fetchGamesList = async () => {
      try {
      const response = await axios.post('/api', {
          method: 'game_list',
          agent_code: agent_code,
          agent_token: agent_token,
          provider_code: selectedProvider,
          user_code: state.values.user_code,
        });
      
      console.log('game_list response.data ', response.data);
      
      // Check for error response
      if (response.data.status === 0) {
        console.warn('API error:', response.data.msg);
        if (response.data.msg === 'Rate Limit Error') {
          console.warn('Rate limit error, retrying in 3 seconds...');
          setTimeout(() => fetchGamesList(), 3000);
          return;
        }
        setGamesList([]);
        return;
      }
      
      // Check if games exists in the data field
      const games = response.data.data?.games || response.data.games;
      if (games && Array.isArray(games)) {
        setGamesList(games);
      } else {
        console.warn('No games data received');
        setGamesList([]);
      }
      } catch (error) {
        console.error('Error fetching games list:', error);
      setGamesList([]); // Set empty array to prevent crashes
      }
    };
  
    if (selectedProvider) {
    fetchGamesList();
    }
  }, [selectedProvider]);

  const launchGame = async (gameCode) => {
    try {
      //for transfer api but better switch to seamless api
      //or in transactions verify by get_game_log
      /*
      const transfer = await axios.post('/api',{
        method: 'user_deposit',
        agent_code: agent_code,
        agent_token: agent_token,
        user_code: state.values.user_code,
        amount: 1,
      });
      */
      const gameLaunchRequest = {
        method: 'game_launch',
        agent_code: agent_code,
        agent_token: agent_token,
        user_code: state.values.user_code,
        provider_code: selectedProvider,
        game_code: gameCode,
        lang: 'en',
      };
      
      console.log('game_launch request:', gameLaunchRequest);
      
      const response = await axios.post('/api', gameLaunchRequest);
      console.log('game_launch response.data ', response.data);
      
      // Check for error response
      if (response.data.status === 0) {
        console.error('Game launch error:', response.data.msg);
        return;
      }
      
      const launchUrl = response.data.data?.launch_url || response.data.launch_url;
      console.log('launch_url ', launchUrl);
      //const newWindow = window.open(response.data.launch_url, '_blank');
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        const iframe = document.createElement('iframe');
        iframe.src = launchUrl;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        newWindow.document.body.appendChild(iframe);

        //newWindow.focus();
      }
    } catch (error) {
      console.error('Error launching game:', error);
    }
  };

  const renderModalContent = () => {
    if (!launchUrl) {
      return <p>Loading...</p>;
    }
  }

  //Top News
  const currentDate = new Date();
  //console.log('state.values.createdAt', state.values.createdAt.split('T')[0])
  //console.log('currentDate.toISOString()', currentDate.toISOString().split('T')[0])
  if (updatedState.createdAt && updatedState.createdAt.split('T')[0] === currentDate.toISOString().split('T')[0]) {
    var notification =
      <div>
        <div className="mb-2"><strong>Thank you for signing up with us!</strong></div>
        {state.values.role === 'agent' ? (<div className="mb-2">Welcome {state.values.name}!</div>
      ) : (<div>Welcome {state.values.name}!</div>)}
        {/*<div className="mb-2">The prohibited areas: Taiwan, Macau, China, Hong Kong, Australia, Canada, Singapore.</div>*/}
        <div className="mb-2">Contact us <Link to="/support" state={{ values: userSession }} style={{ color: 'white' }}>contact</Link></div>
        <div className="mb-2">Play more <Link to="/pay" state={{ values: userSession }} style={{ color: 'white' }}>$$$</Link></div>
      </div>
  } else {
    var notification =
      <div>
        {state.values.role === 'user' ? (<div className="mb-2">Welcome {state.values.name}!</div>) : (<div>Welcome {state.values.name}!</div>)}
        {/*<div className="mb-2">The prohibited areas: Taiwan, Macau, China, Hong Kong, Australia, Canada, Singapore.</div>*/}
        <div className="mb-2">Any questions? <Link to="/support" state={{ values: userSession }} style={{ color: 'white' }}>contact us</Link></div>
        <div className="mb-2">12+ more iGaming providers <Link to="/pay" state={{ values: userSession }} style={{ color: 'white' }}>activate</Link></div>
      </div>
  }

  //JILI
  const [selectedCategory, setSelectedCategory] = useState('2');
  const [filteredJiliGames, setFilteredJiliGames] = useState([]);
  const [jiliGameCategoryId, setjiliGameCategoryId] = useState([]);
  // Importing images dynamically
  const importImagesById = (context) => {
    let imagesById = {};
    context.keys().forEach((key) => {
      const matches = key.match(/\d+/g); // Extracting numeric ID(s) from the filename
      if (matches) {
        matches.forEach((imageId) => {
          imagesById[imageId] = context(key);
        });
      }
    });
    return imagesById;
  };
  var imagesById = importImagesById(require.context('../images/128x128', false, /\.(png|jpg)$/));
  const getBetRecordSummary = async () => {
    try {
      const EndTime = new Date();
      const formattedEndTime = format(EndTime, "yyyy-MM-dd'T'HH:mm:ss");
      var StartTime = new Date(EndTime - 72 * 60 * 60 * 1000);
      var formattedStartTime = format(StartTime, "yyyy-MM-dd'T'HH:mm:ss");
      const response = await axios.get(`/callbackurl/getbetrecordsummary?StartTime=${formattedStartTime}&EndTime=${formattedEndTime}`);
    } catch (error) {
      console.error('Error fetching getBetRecordSummary list:', error);
    }
  }

  const getMemberInfo = async () => {
    try {
      const response = await axios.get(`/callbackurl/getmemberinfo?user_code=${state.values.user_code}`);
      //console.log('response GetMemberInfo:', response);
    } catch (error) {
      console.error('Error fetching GetMemberInfo list:', error);
    }
  }

  const fetchGamesList = async () => {
    try {
      const response = await axios.post(`/callbackurl/getgamelist?user_code=${state.values.user_code}`);
      const jiliGameCategoryId = [
        { "GameCategoryId": 1, "Category": "Slot" },
        { "GameCategoryId": 2, "Category": "Poker" },
        { "GameCategoryId": 3, "Category": "Lobby" },
        { "GameCategoryId": 5, "Category": "Fishing" },
        { "GameCategoryId": 8, "Category": "Casino (including bingo)" },
      ];
      //console.log('jiliGameCategoryId ', jiliGameCategoryId)
      //console.log('response ', response)
      setjiliGameCategoryId(jiliGameCategoryId);

      const filteredGamesData = response.data.Data.filter(game => selectedCategory.includes(game.GameCategoryId));
      setFilteredJiliGames(filteredGamesData);
    } catch (error) {
      console.error('Error fetching gamesJili list:', error);
    }
  };
  const getCategoryName = (categoryId) => {
    const category = jiliGameCategoryId.find((cat) => cat.GameCategoryId === categoryId);
    return category ? category.Category : 'Unknown';
  };
  useEffect(() => {
    fetchGamesList();
    getMemberInfo();
    //getBetRecordSummary(); The frequency of same request is too high, Please try again later
  }, [state, selectedCategory]);

  const openJiliContentInNewWindow = async (gameId) => {
    try {
      const lang = "en-US";
      const currency = "USD";
      const loginResponse = await axios.get(`/callbackurl?GameId=${gameId}&user_code=${state.values.user_code}&Lang=${lang}&currency=${currency}&balance=${state.values.balance}&agent_code=${state.values.agent_code}&agent_token=${state.values.agent_token}`);
      // Process the login response as needed
      console.log('state.values.user_code ',state.values.user_code);
      console.log('state.values.balance ',state.values.balance);
      console.log('loginResponse:', loginResponse);
      console.log('loginResponse.data.Data:', loginResponse.data.Data);
      //const newWindow = window.open(loginResponse.data.Data, '_blank');
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        // Focus on the new window (optional)
        const iframe = document.createElement('iframe');
        iframe.src = loginResponse.data.Data;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        newWindow.document.body.appendChild(iframe);
        //newWindow.focus();

        //const response = await axios.get(`/callbackurl/getmusthitby?GameId=${gameId}`);
        //console.log('response getMustHitBy:', response);

      }
    } catch (error) {
      console.error('Error fetching login data:', error);
    }
  }

  return (
    <React.StrictMode>
      <div className="d-flex w-100 vh-100 justify-content-center align-items-start">
        <div className="d-flex w-10 vh-100 justify-content-center align-items-start"><NavBar state={{ values: userSession }} /></div>
        <div className="d-grid w-90 vh-1000 p-2 rounded bg-white">
          <div className="d-flex w-100 vh-10 justify-content-center align-items-start"><Panel state={{ values: userSession }} updateValues={updateValues} /></div>
          <h2>Dashboard</h2>
          <div className="row">
            <div className="form-control d-flex w-100 vh-20 justify-content-around align-items-start">
              <div className="mb-2">
                <label htmlFor="currency"><strong>Currency:</strong></label>
                <span>{state.values.currency}</span>
              </div>
              <div className="mb-2">
                <label htmlFor="fee"><strong>API Fee:</strong></label>
                <span>{state.values.comission}%</span>
              </div>
            </div>

            <div className="form-control d-flex w-100 vh-20 justify-content-around align-items-start">
              <div className="mb-2">
                <label htmlFor="currency"><strong>Currency Rate (USD:{state.values.currency}):</strong></label>
                <span>1:{state.values.currency_rate}</span>
              </div>
              <div className="mb-2">
                <label htmlFor="calculation"><strong>Calculation:</strong></label>
                <span>100USD=100USD*{state.values.currency_rate}/({state.values.comission}/100)={(100 * state.values.currency_rate / (state.values.comission / 100)).toFixed(4)} tokens</span>
              </div>
            </div>
          </div>

          <div className="form-control d-flex w-100 vh-20 justify-content-around align-items-start bg-success text-white">
            <div className="mb-2">
              <label htmlFor="notification"><strong>Free spins added!</strong></label>
              <br></br>
              <span>↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓</span>
            </div>
            <div className="mb-2">
              <label htmlFor="notification"><strong>{notification}</strong></label>
              <span></span>
            </div>
          </div>

          <div className="mb-2 justify-content-center align-items-start">
            <label htmlFor="providers"><strong>Featured JILI provider </strong></label>
            <select
              id="providers"
              name="providers"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="" disabled>Select category</option>
              {jiliGameCategoryId.map((category) => (
                <option key={category.GameCategoryId} value={category.GameCategoryId}>
                  {category.Category}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            {filteredJiliGames.map((game) => (
              <div className="mb-2"
                key={game.GameId}
                style={{
                  marginBottom: '1px',
                  flex: '0 0 10%',
                  boxSizing: 'border-box',
                  padding: '0 1px',
                  cursor: 'pointer',
                }}
              >
                <div className="mb-2">
                  <div className="mb-2 justify-content-center align-items-start">
                    <img onClick={() => openJiliContentInNewWindow(game.GameId)} src={imagesById[game.GameId]} alt={game.name['en-US'] || game.name['zh-CN'] || game.name['zh-TW']} />
                  </div>
                  {/*
                  <div className="mb-2">
                    <strong>Game name:</strong><br />
                    English:{game.name['en-US']}<br />
                    Chinese:{game.name['zh-CN']}<br />
                    Taiwan:{game.name['zh-TW']}
                  </div>
                  <div className="mb-2">
                    <strong>ID:</strong> {game.GameId}
                  </div>
                  <div className="mb-2">
                    <strong>Category:</strong> {getCategoryName(game.GameCategoryId)}
                  </div>
                  <div className="mb-2">
                    <strong>Jackpot:</strong> {game.JP ? 'Yes' : 'No'}
                  </div>
                  <div className="mb-2">
                    <strong>Free Spin:</strong> {game.Freespin ? 'Yes' : 'No'}
                  </div>
              */}
                </div>
              </div>
            ))}
          </div>
          {/*12 providers*/}

          <div className="mb-2 justify-content-center align-items-start">
            <label htmlFor="providers"><strong>12 more providers</strong></label>
            <select
              id="providers"
              name="providers"
              value={selectedProvider}
              onChange={(e) => setSelectedProvider(e.target.value)}
            >
              <option value="" disabled>Select a provider</option>
              {providersList && providersList.map((provider) => (
                <option key={provider.id} value={provider.code}>
                  {provider.name}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            {gamesList.map((game) => (
              <div
                key={game.id}
                style={{
                  marginBottom: '1px',
                  flex: '0 0 10%',
                  boxSizing: 'border-box',
                  padding: '0 1px',
                  cursor: 'pointer',
                }}
                onClick={() => launchGame(game.game_code)}
              >
                <div style={{ width: '100px', overflow: 'hidden' }}>
                  <img src={game.banner} alt={game.game_name} style={{ width: '100%', height: '100%', marginBottom: '1px' }} />
                </div>
                {/*<span>{ showModal ? ( <a href={launchUrl} title="Launch game" target='blank'>{game.game_name}</a> ) : renderModalContent() }</span>*/}
              </div>
            ))}
          </div>

          <Bottom />
        </div>
      </div>

    </React.StrictMode>

  );
}
export default Home;
